import PageState from "./state"
import mutations from "./mutations"
import { getModule } from "@/store/store"
let u = navigator.userAgent;
let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
let device= isAndroid?"H5_ANDROID":"H5_IOS"
let APIS = {
  //ajax地址
  getDataList: `post ${process.env.VUE_APP_API_ROOT}plate/queryDemandList.htm `,
  getSearchSpeaker: `get /apis/tts-web-api/v4/speaker/search`,
  getSaleOffPrice: `/apis/tts-web-api/v1/sale-off/getSaleOffPrice?type=1`,
  getKeyWordSearch: `post /apis/getKeyWordSearch`,
  getStoreSearchCriteria: `get /apis/tts-web-api/v1/storeSpeakerV2/getStoreSearchCriteria`, // 常用发音人
  getMySpeakerEmotionList: `get /apis/tts-web-api/v1/speaker/getSpeakerEmotionList`, // 常用发音人
  // 支付费用
  payVoiceStore: {
    custom: true,
    url: (data: any) =>
      `/apis/tts-web-api/v1/storeSpeaker/wxJsCodeApiOrder?phone=${data.phone}&storeId=${data.storeId}&jsCode=${data.jsCode}&channelCode=${data.channelCode}&device=${device}&payType=${data.payType}`,
    method: "post",
  },
  // 获取渠道名称
  getChannelName: {
    custom: true,
    url: `/apis/moyin-account/v1/vip/getWxJsApiChannelName?`,
    method: "get",
  },
}
export default {
  ...getModule({
    state: new PageState(),
    mutations,
    actions: {},
    APIS,
    name: "voiceShopPage",
  }),
}
